import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { validatable } from 'components/utils';
import { LetterProcessingWorkFlow } from 'api';

class DropDownChonNguonDon extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      dataNguonDon: []
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      LetterProcessingWorkFlow.actions.getNguonDon.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'nguonDon',
            data: res.data
          }]
        })
      })
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.length) {
      let data = [];
      if (this.props.exceptNguonDon) {
        let arrExceptNguonDon = this.props.exceptNguonDon.split(",").map(String);
        this.state.dataNguonDon = [];
        nextProps.data.map((item, i) => {

          let exist = false;

          arrExceptNguonDon.map(child => {
            if (child == item.giaTri)
              exist = true;
          })

          if (!exist)
            data.push(item);
        })

      } else {
        data = nextProps.data;
      }

      this.setState({dataNguonDon: data});
    }
  }

  render() {
    return (
      <DropDown label="Nguồn đơn"
        name={this.props.name}
        bindValidator={this}
        channel="formTaoDon"
        require={this.props.require}
        selectedValue={this.props.selectedValue}
        options={this.state.dataNguonDon}
        keyName='giaTri' valueName='ten'
        onChange={this.onChange.bind(this)}
        placeholder
        className={this.props.className} />
    )
  }
}

DropDownChonNguonDon.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  name: 'nguonDon',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.nguonDon
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonNguonDon));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonnguondon.jsx